import classNames from 'classnames';
import React from 'react';
import styles from './tabs.module.css.js';

function Tablist({ children, align = 'vertical' }) {
    return (React.createElement("div", { role: 'tablist', className: classNames(styles.tablist, { [styles[align]]: align }) }, children));
}

export { Tablist as default };
